<template>
    <div class="custom-main-popover">

        <b-button id="snippets-popover" class="snippetTooltip" href="#" tabindex="0" title="Snippets" @click="showHideSnippetPopover()" :disabled="!loadingData" :title="(loadingData)? '':'Loading Snippets'">
            <b-spinner small variant="primary" label="Spinning" class="" v-if="!loadingData"></b-spinner>
            <i class="fa fa-file-text-o" aria-hidden="true" v-if="loadingData"></i>
        </b-button>

        <div class="popover-custom  border-1 border-grey-light" id="popOverForSnippetCustom">
            <div class="custom-popover-align">
                <div class="popver-title">
                    <div class="d-flex justify-content-between mr-2">
                        <div>
                            <h5>Snippets</h5>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-sm" @click="newFolderModal()"><i class="fa fa-folder-o mr-2" aria-hidden="true"></i>New folder</button>
                            <button class="btn btn-primary btn-sm" @click="newSnippetModal()"><i class="fa fa-file-text-o mr-2" aria-hidden="true"></i>New snippet</button>
                        </div>

                    </div>

                    <p class="text-black cursor-pointer w-100 my-3" @click="backToRoot()" v-if="selectedFolder">
                        <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back
                    </p>
                </div>
                <div class="folders-popover mt-3 mr-2">
                    <div v-if="allData.length > 0 && loadingData">
                        <div class="card m-0 p-2 cursor-pointer shadow-none mt-1 hover:bg-teal-light hover:text-white" :class="(data.is_folder)? 'bg-grey-light':'bg-grey-light'" v-for="data in allData" :key="data.id" @click="openFolderOrSnippet(data)">
                            <div class="card-body m-0 p-2 d-flex justify-content-between">
                                <div>
                                    <i class="fa fa-folder mr-2" v-if="data.is_folder" aria-hidden="true"></i> {{ data.name }}
                                </div>
                                <div>
                                    <i class="fa fa-arrow-right" v-if="data.is_folder" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="allData.length === 0 && loadingData" class="d-flex justify-content-center">
                        No snippet or folder created yet
                    </div>
                    <div v-if="!loadingData" class="d-flex justify-content-center">
                        <b-spinner variant="primary" label="Spinning" class="mr-2"></b-spinner> Fetching snippets and folders
                    </div>
                </div>
            </div>
        </div>

        <!--   New folder Modal   -->
        <snippets-new-folder-modal
            ref="SnippetNewFolderModal"
            :selected-folder-for-edit="selectedFolderForEdit"
            :all-folders="allFolders"
        ></snippets-new-folder-modal>

        <!--  New Snippet Modal -->
        <snippet-modal
            ref="SnippetModal"
            :selected-snippet-for-edit="selectedSnippetForEdit"
            :all-folders="allFolders"
        ></snippet-modal>

    </div>
</template>


<script>

import SnippetsNewFolderModal from "../settings/snippets-new-folder-modal.vue";
import axios from "axios";
import SnippetModal from "../settings/snippet-modal.vue";

export default {
    name: "snippets-popover",
    props:[],
    components: {SnippetModal, SnippetsNewFolderModal},
    data() {
        return {
            selectedFolderForEdit: null,
            allData: [],
            allFolders: [],
            allSnippets: [],
            selectedFolder: null,
            selectedSnippetForEdit: null,
            loadingData: false,
            searchText: '',
            selectedFilter: '1',
        };
    },
    mounted(){
        this.getData();
    },
    methods: {
        getData(){
            this.$nextTick(() => {
                this.loadingData = false;
                axios.post(route('snippet.all-data'), {filter:this.selectedFilter}).then(response => {
                    this.allData = response.data.data;
                    this.allFolders = response.data.allFolders;
                    this.allSnippets = response.data.allSnippets;
                    this.selectedFolder = null;
                    this.loadingData = true;
                    setTimeout(() => {
                        $('.snippetTooltip').tooltip();
                    }, 1000)
                });
            });
        },
        newFolderModal(){
            this.showHideSnippetPopover();
            this.$refs.SnippetNewFolderModal.newFolderModal();
        },
        newSnippetModal(){
            this.showHideSnippetPopover();
            this.$refs.SnippetModal.newSnippetModal();
        },
        formatDate(createdAt){
            return moment.utc(createdAt).local().format('MMMM Do, YYYY h:mm A');
        },
        openFolderOrSnippet(data){
            if(data.is_folder){
                this.selectedFolder = data;
                this.fetchDataOfFolder(data.id);
            }else{
                this.$parent.insertSnippet(data.snippet);
                this.showHideSnippetPopover();
            }
        },
        fetchDataOfFolder(folderId){
            this.loadingData = false;
            axios.post(route('snippet.folder.folder-data'), {folderId: folderId, filter:this.selectedFilter}).then(response => {
                this.allData = response.data.data;
                this.loadingData = true;
                setTimeout(() => {
                    $('.snippetTooltip').tooltip();
                }, 1000)
            });
        },
        backToRoot(){
            if(this.selectedFolder.parent){
                this.fetchDataOfFolder(this.selectedFolder.parent.id);
                this.selectedFolder = this.selectedFolder.parent;
            }else{
                this.loadingData = false;
                this.getData();
                this.selectedFolder = null;
            }
        },
        editFolderSnippet(data){
            if(data.is_folder){
                this.selectedFolderForEdit = data;
                this.$nextTick(() => {
                    this.$refs.SnippetNewFolderModal.newFolderModal();
                })
            }else{
                this.selectedSnippetForEdit = data;
                this.$nextTick(() => {
                    this.$refs.SnippetModal.newSnippetModal();
                });
            }
        },
        deleteFolderSnippet(data){
            axios.post(route('snippet.delete'), {data: data}).then(response => {
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.selectedFolder = null;
                this.allData = response.data.data;
                this.loadingData = true;
                setTimeout(() => {
                    $('.snippetTooltip').tooltip();
                }, 1000)
                this.getData();
            });
        },
        searchData(){
            this.$nextTick(() => {
                if(this.searchText){
                    this.loadingData = false;
                    axios.post(route('snippet.search-data'), {filter:this.selectedFilter, search: this.searchText}).then(response => {
                        this.allData = response.data.data;
                        this.selectedFolder = null;
                        this.loadingData = true;
                        setTimeout(() => {
                            $('.snippetTooltip').tooltip();
                        }, 1000)
                    });
                }else{
                    this.getData();
                }
            });
        },
        changeFilter(){
            if(this.searchText){
                this.searchData();
            }else{
                this.getData();
            }
        },
        showHideSnippetPopover(){
            let popoverDiv = $('.popover-custom');
            if (popoverDiv.hasClass('show-popover')) {
                popoverDiv.removeClass('show-popover');
            } else {
                popoverDiv.addClass('show-popover');
            }
        },
    }
};
</script>
<style>
#snippetPopover,
.popover .snippetDivClass{
    width: 100% !important;
    max-width: 600px !important;
}

.custom-main-popover {
    position: relative;
}

.popover-custom {
    position: absolute;
    bottom: 50px;
    min-width: 400px;
    background: #fff;
    padding: 10px;
    z-index: 9999;
    right: auto;
    //left: auto;
    //left: -70px;
    border-radius: 6px;
    transition: .3s linear;
    opacity: 0;
    visibility: hidden;
}

.snippetPopOverProjectComment .popover-custom {
    left: 0 !important;
}

.snippetPopOverPGEditor .popover-custom,
.snippetPopOverCompanyNotes .popover-custom,
.snippetPopOverContactNotes .popover-custom {
    left: -950% !important;
}


.custom-popover-align {
    min-height: 280px;
    position: relative;
    max-height: 350px;
    overflow: auto;
}

.custom-popover-align::before {
    border-top: 10px solid #ffffff;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    content: '';
    position: absolute;
    bottom: -20px;
    left: 84%;
}

.popover-custom.show-popover {
    opacity: 1;
    visibility: visible;
}

#snippets-popover .spinner-border.spinner-border-sm.text-primary {
    color: white !important;
}

</style>
